"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.content = void 0;
require("babel-polyfill");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const m = require("../SynView");
class content extends m.SynView {
    constructor() {
        super();
    }
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        this.m_contentType = typeof $.address.parameter("contentType") === "undefined" ? undefined : decodeURIComponent($.address.parameter("contentType"));
    }
    executeView() {
        Utilities_1.synUtil.viewInstance({
            id: this.m_id,
            contentType: parseInt(this.m_contentType, 10),
            done(result) {
                if (window.opener)
                    window.close();
            }
        });
    }
    renderContents() {
        const that = this;
        that.m_$container.find(".contentStaticText > .textBar").text(Utilities_1.synUtil.Strings.getValue("webtoolkit.contentviewtext"));
        that.m_$container.find(".btn.viewButton")
            .text(Utilities_1.synUtil.Strings.getValue("cefunc.26"))
            .click(that.executeView.bind(that));
        that.executeView();
    }
    forceRefresh(modifications) { }
}
exports.content = content;
